import React from 'react';
import { cn } from './cn.js';

export default function Switch({ checked, onCheckedChange, disabled = false, className }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={Boolean(checked)}
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        onCheckedChange?.(!checked);
      }}
      className={cn(
        'relative inline-flex h-7 w-12 items-center rounded-full border transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ptcm-primary focus-visible:ring-offset-2',
        'ring-offset-ptcm-bg dark:ring-offset-gray-900',
        disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer',
        checked
          ? 'bg-ptcm-primary border-ptcm-primary'
          : 'bg-ptcm-panel dark:bg-gray-800 border-ptcm-border dark:border-gray-700',
        className
      )}
    >
      <span
        className={cn(
          'inline-block h-5 w-5 transform rounded-full bg-white shadow-sm transition-transform',
          checked ? 'translate-x-6' : 'translate-x-0.5'
        )}
      />
    </button>
  );
}

